import { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import { useDispatch } from "react-redux";
import {
  Alerterror,
  Alertsuccess,
  EncodeString,
  DecodeString,
} from "../../Utils";
import { mainAction } from "../../Redux/Actions";
import { Img } from "react-image";
import { useInput } from "../../Hooks";
import { axiosClient, getToken } from "../../Services/axiosClient";
import { Modal, Input, Button } from "antd";
import Cookies from "js-cookie";
import "./PolicyModal.css";

const LoginV4Component = () => {
  const dispatch = useDispatch();

  const [Username, bindUserName] = useInput("");
  const UsernameRef = useRef();

  const [Password, bindPassword] = useInput("");
  const PasswordRef = useRef();

  const [LoginMessage, setLoginMessage] = useState("");
  const [disable, setDisable] = useState(false); // disable button

  const [UserActive, setUserActive] = useState("");
  const [PassActive, setPassActive] = useState("");

  const [PassHide, setPassHide] = useState("password");
  const [PassEye, setPassEye] = useState("");

  const [isModalVisible, setIsModalVisible] = useState(false);
  const [dataLogin, setDataLogin] = useState(null);
  const [isLast, setIsLast] = useState(1); //1 Single,2 Group
  const [isLock, setIsLock] = useState(false);

  const [showOTPForm, setShowOTPForm] = useState(false);
  const [otpMethod, setOTPMethod] = useState(""); // 'email', 'sms', or 'zalo'
  const [otp, setOtp] = useState("");
  const [isVerifying, setIsVerifying] = useState(false);

  // Authentication States
  const [showVerificationModal, setShowVerificationModal] = useState(false);
  const [verificationStep, setVerificationStep] = useState(1); // 1: choose method, 2: enter OTP
  const [verificationMethod, setVerificationMethod] = useState("email");
  const [otpInputs, setOtpInputs] = useState(["", "", "", "", "", ""]);
  const [maskedContact, setMaskedContact] = useState("");
  const [isDeviceVerified, setIsDeviceVerified] = useState(false);
  const [otpData, setOtpData] = useState(null);
  const [countdown, setCountdown] = useState(0);
  const [allowCloseVerification, setAllowCloseVerification] = useState(false);

  // Handle closing verification modal
  const handleCloseVerification = () => {
    setShowVerificationModal(false);
    setOtpInputs(["", "", "", "", "", ""]);
    setVerificationStep(1);
  };

  // Handle OTP input change
  const handleOtpChange = (index, value) => {
    if (value.length <= 1 && /^\d*$/.test(value)) {
      const newOtpInputs = [...otpInputs];
      newOtpInputs[index] = value;
      setOtpInputs(newOtpInputs);

      // Auto focus next input
      if (value && index < 5) {
        const nextInput = document.getElementById(`otp-input-${index + 1}`);
        if (nextInput) nextInput.focus();
      }
    }
  };

  // Cập nhật hàm handleSelectMethod
  const handleSelectMethod = async () => {
    try {
      mainAction.LOADING({ IsLoading: true }, dispatch);
      // Xác định loại tài khoản và lấy thông tin liên hệ
      let contactPhone = "";
      let contactEmail = "";

      if (dataLogin) {
        if (isLast === 2) {
          // Group
          // Tài khoản nhóm - lấy từ CustomerGroup
          contactPhone = dataLogin.CustomerGroup[0].Phone || "";
          contactEmail = dataLogin.CustomerGroup[0].MailGroup || "";
          console.log(
            "[OTP] Tài khoản nhóm - Phone:",
            contactPhone,
            "Email:",
            contactEmail
          );
        } else {
          if (dataLogin.CustomerStaff.length > 0) {
            // Staff account
            contactPhone = dataLogin.CustomerStaff[0].Phone || "";
            contactEmail = dataLogin.CustomerStaff[0].Email || "";
            console.log(
              "[OTP] Tài khoản nhân viên - Phone:",
              contactPhone,
              "Email:",
              contactEmail
            );
          } else {
            contactPhone = dataLogin.Customers[0].Phone || "";
            contactEmail = dataLogin.Customers[0].Email || "";
            console.log(
              "[OTP] Tài khoản thường - Phone:",
              contactPhone,
              "Email:",
              contactEmail
            );
          }
        }
      }

      let response;
      if (verificationMethod === "zalo") {
        // Gọi API gửi OTP qua Zalo

        const params = {
          Json: JSON.stringify({
            Phone: contactPhone,
            Channel: 1,
            ShowOTP: 0, // Không show mã OTP ra response
            RecipientType: isLast,
          }),
          func: "CPN_spOfficer_UpdateOTP_V3",
        };
        response = await mainAction.API_spCallServer(params, dispatch);
      } else {
        // Gửi qua email
        const pr = {
          Json: JSON.stringify({
            Phone: "",
            Email: contactEmail,
            // Email: "clatshvn@gmail.com",
            Channel: 3,
            ShowOTP: 0,
            RecipientType: isLast,
          }),
          func: "CPN_spOfficer_UpdateOTP_V3",
        };
        response = await mainAction.API_spCallServer(pr, dispatch);
      }

      if (response && response.Status === "OK") {
        setOtpData(response);
        startCountdown();
        setVerificationStep(2);

        // Set masked contact
        if (verificationMethod === "email" && contactEmail) {
          setMaskedContact(maskEmail(contactEmail));
        } else if (contactPhone) {
          setMaskedContact(maskPhone(contactPhone));
        }

        Alertsuccess(
          `Mã OTP đã được gửi đến ${
            verificationMethod === "email" ? "email" : "số điện thoại Zalo"
          } của bạn`
        );
      } else {
        Alerterror(response?.Message || "Lỗi gửi mã OTP. Vui lòng thử lại sau");
      }
    } catch (error) {
      console.error("Error in handleSelectMethod:", error);
      Alerterror("Không thể gửi mã OTP. Vui lòng thử phương thức khác");
    }
  };

  // Verify OTP
  const handleVerifyOtp = async () => {
    const enteredOtp = otpInputs.join("");

    if (!enteredOtp) {
      Alerterror("Vui lòng nhập mã OTP");
      return;
    }

    const params = {
      Json: JSON.stringify({
        OTP_Code: enteredOtp,
        Channel: verificationMethod === "zalo" ? 1 : 3,
        ShowOTP: 0, // Không show mã OTP ra response
        RecipientType: isLast,
      }),
      func: "CPN_spOfficer_VerifyOTP_V2",
    };
    const response = await mainAction.API_spCallServer(params, dispatch);
    if (response && response.Status === "OK") {
      setIsDeviceVerified(true);
      setAllowCloseVerification(true); // Allow modal to close after successful verification
      setShowVerificationModal(false);

      // Lưu thời gian xác thực kèm username vào cookie, hết hạn sau 30 ngày
      const verificationData = {
        username: Username,
        timestamp: new Date().toISOString(),
      };
      Cookies.set("netco_device_verified", JSON.stringify(verificationData), {
        expires: 30,
      });

      Alertsuccess("Xác thực thành công");
      proceedWithLogin();
    } else {
      Alerterror("Mã OTP không đúng. Vui lòng thử lại");
    }
  };

  const showModal = () => {
    setIsModalVisible(true);
  };

  const handleOk = () => {
    setIsModalVisible(false);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  useEffect(() => {
    // Kiểm tra xem đã đăng nhập trước đó chưa
    // const savedLogin = localStorage.getItem("clgv3");
    // if (savedLogin) {
    //   try {
    //     const loginData = JSON.parse(DecodeString(savedLogin));
    //     // Kiểm tra xem có dữ liệu hợp lệ không
    //     if (loginData && (loginData.Active || loginData.Group)) {
    //       window.location.href = "/home";
    //       return;
    //     }
    //   } catch (error) {
    //     console.error("Error parsing saved login:", error);
    //     // Nếu có lỗi, xóa dữ liệu không hợp lệ
    //     localStorage.removeItem("clgv3");
    //   }
    // }

    localStorage.setItem("login", "");
    let currentDate = new Date();
    if (currentDate.getHours() < 12)
      setLoginMessage("Chào buổi sáng. Chúc bạn ngày mới tràn đầy năng lượng");
    else if (currentDate.getHours() > 12 && currentDate.getHours() < 18)
      setLoginMessage("Buổi chiều của bạn thế nào ?");
    else setLoginMessage("Hôm nay có gì mới ?");
  }, []);

  // Login form submission
  const onClickLogin = async () => {
    setUserActive("");
    setPassActive("");
    if (Username === "") {
      Alerterror("Thông tin đăng nhập không được để trống");
      setUserActive("form-error");
      return;
    } else if (Password === "") {
      Alerterror("Mật khẩu không được để trống");
      setUserActive("");
      setPassActive("form-error");
      return;
    }

    if (Password.toLowerCase().includes("netco")) {
      setIsLock(true);
    }
    if (Username === Password) {
      setIsLock(true);
    }
    const regex =
      /^(?=.*[A-Za-z])(?=.*\d)(?=.*[!@#$%^&*()_\-+=\[\]{};':"\\|,.<>/?]).{8,}$/;
    if (!regex.test(Password)) {
      setIsLock(true);
    }

    try {
      let pr = {
        Json: '{"UserName":"' + Username + '","Password":"' + Password + '"}',
        func: "APIC_spCustomerCheckLoginGroup",
      };

      const data = await axiosClient.API_Login(pr);
      const { CustomerGroup, Customers, CustomerStaff } = data;
      if (CustomerGroup.length === 0 && Customers.length === 0) {
        Alerterror("Tài khoản hoặc mật khẩu không đúng");
        return;
      }
      let checkType = 2; // Nhóm KH
      if (CustomerGroup.length > 0) {
        // Set Account_Id for group login
        CustomerGroup[0].Account_Id = CustomerGroup[0].Id;
        await getToken(CustomerGroup[0]);
        setIsLast(2); //Group
        checkType = 2;
      } else if (Customers.length === 1) {
        // Fix Id field and set Account_Id for single customer

        if (CustomerStaff.length > 0) {
          // Set Account_Id for staff login
          Customers[0].Account_Id = Customers[0].CustomerID;
          await getToken(Customers[0]);
        } else {
          Customers[0].Account_Id = Customers[0].CustomerID;
          await getToken(Customers[0]);
        }
        setIsLast(1); // Single
        checkType = 1;
      }
      await setDataLogin(data);
      await showAuthenticationModal(data, checkType);
    } catch (ex) {
      Alerterror("Lỗi. Vui lòng liên hệ CSKH");
      console.error(ex);
    }
  };

  // 30 ngafy moi het thoi gina
  const isDeviceVerifiedRecently = (username) => {
    const verifiedData = Cookies.get("netco_device_verified");
    if (!verifiedData) return false;

    try {
      const parsed = JSON.parse(verifiedData);
      // Kiểm tra xem có phải tài khoản hiện tại không
      if (parsed.username !== username) return false;

      const verifiedDate = new Date(parsed.timestamp);
      const currentDate = new Date();
      const diffInDays = (currentDate - verifiedDate) / (1000 * 60 * 60 * 24);
      return diffInDays <= 30;
    } catch (error) {
      return false;
    }
  };

  // Show authentication modal
  const showAuthenticationModal = (data, checkType) => {
    // neu da xac thuc trong 30 ngay
    if (isDeviceVerifiedRecently(Username)) {
      proceedWithLogin(1, data, checkType);
      return;
    }

    setShowVerificationModal(true);
    setVerificationStep(1);
    setVerificationMethod("email"); // Default method
  };

  const CodeHandleKeyDown = (e) => {
    if (e.key === "Enter") {
      onClickLogin();
    }
  };

  const startCountdown = () => {
    setCountdown(60); // 3 minutes
  };

  useEffect(() => {
    if (countdown > 0) {
      const timer = setTimeout(() => setCountdown(countdown - 1), 1000);
      return () => clearTimeout(timer);
    }
  }, [countdown]);

  // Add these utility functions
  const maskEmail = (email) => {
    if (!email) return "";
    const [username, domain] = email.split("@");
    const maskedUsername =
      username.charAt(0) +
      "*".repeat(username.length - 2) +
      username.charAt(username.length - 1);
    return `${maskedUsername}@${domain}`;
  };

  const maskPhone = (phone) => {
    if (!phone) return "";
    return phone.slice(0, 3) + "*".repeat(phone.length - 6) + phone.slice(-3);
  };

  // Complete the login process
  const proceedWithLogin = async (type = 0, data, checkType) => {
    setDisable(true);
    try {
      let dtLogin = new Object();

      // Nếu type = 1, sử dụng data và checkType; ngược lại dùng dataLogin và isLast
      const loginData = type === 1 ? data : dataLogin;
      const accountType = type === 1 ? checkType : isLast;

      if (accountType === 2) {
        //Đăng nhập bằng user nhóm KH
        dtLogin.IsLoginByGroup = 1;
        dtLogin.Group = loginData.CustomerGroup[0];
        dtLogin.Customers = loginData.Customers;
        dtLogin.Active = null;
        dtLogin.IsLock = false; // tạm thời chưa bắt tài khoản nhóm đổi mật khẩu
        let enscG = EncodeString(JSON.stringify(dtLogin));
        localStorage.setItem("clgv3", enscG);
        window.location.href = "/home";
      } else if (accountType === 1) {
        //Đăng nhập bằng user KH
        if (loginData.CustomerStaff.length > 0) {
          dtLogin.IsLoginByGroup = 0;
          dtLogin.Group = null;
          dtLogin.Customers = loginData.Customers;
          //replace name customer, nối thêm tên customer Staff vào
          dtLogin.Customers[0].StaffName = `${loginData.CustomerStaff[0].CustomerCode} - ${loginData.CustomerStaff[0].StaffName}`;

          dtLogin.Active = loginData.Customers[0];
          dtLogin.CustomerStaff = loginData.CustomerStaff;
          dtLogin.IsLock = false;
        } else {
          dtLogin.IsLoginByGroup = 0;
          dtLogin.Group = null;
          dtLogin.Customers = loginData.Customers;
          dtLogin.Active = loginData.Customers[0];
          dtLogin.IsLock = isLock;
        }
        let enscG = EncodeString(JSON.stringify(dtLogin));
        localStorage.setItem("clgv3", enscG);
        window.location.href = "/home";
      } else {
        Alerterror("Tài khoản hoặc mật khẩu không đúng");
      }
    } catch (ex) {
      console.error(ex);
      Alerterror("Lỗi. Vui lòng liên hệ CSKH");
    } finally {
      setDisable(false);
      mainAction.LOADING({ IsLoading: false }, dispatch);
    }
  };

  return (
    <div className="content-login">
      <div className="container container-login">
        <div className="row">
          <div className="col-md-12 text-center mb10">
            <Img
              src="assets/img/LogoNetco.png"
              className="margin-left-5"
              width="200"
            />
          </div>
        </div>
        <div className="row">
          <div className="col-md-6 hide-sm">
            <h3 className="bold">
              <span className="red">NETCO</span> CÓ GÌ HOT ?
            </h3>
            <div className="row margin-top-10">
              <div className="col-md-12 margin-top-10">
                <h4 className="bold">
                  {" "}
                  <Img
                    src="/assets/img/tick.png"
                    className="logocustom"
                    width="20"
                  />{" "}
                  Vận chuyển an toàn{" "}
                </h4>
                <div className="italic sm">
                  {" "}
                  Hàng hóa của khách hàng được bảo đảm an toàn tới tay người
                  nhận{" "}
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-12">
                <h4 className="bold">
                  {" "}
                  <Img
                    src="/assets/img/tick.png"
                    className="logocustom"
                    width="20"
                  />{" "}
                  Hỗ trợ tư vấn linh hoạt{" "}
                </h4>
                <div className="italic sm">
                  {" "}
                  Khách hàng luôn được chăm sóc chu đáo - nhiệt tình ở mọi thời
                  điểm{" "}
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-12">
                <h4 className="bold">
                  {" "}
                  <Img
                    src="/assets/img/tick.png"
                    className="logocustom"
                    width="20"
                  />{" "}
                  Thanh toán dễ dàng{" "}
                </h4>
                <div className="italic sm">
                  {" "}
                  Phương thức thanh toán linh hoạt, tiện lợi mà vẫn giữ được sự
                  an toàn{" "}
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-12">
                <h4 className="bold">
                  {" "}
                  <Img
                    src="/assets/img/tick.png"
                    className="logocustom"
                    width="20"
                  />{" "}
                  Vận chuyển đúng giờ{" "}
                </h4>
                <div className="italic sm">
                  {" "}
                  Luôn luôn đúng giờ là một ưu điểm tuyệt vời mà NETCO có được{" "}
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-12">
                <h4 className="bold">
                  <Img
                    src="/assets/img/tick.png"
                    className="logocustom"
                    width="20"
                  />{" "}
                  Nhân viên nhiệt tình
                </h4>
                <div className="italic sm">
                  {" "}
                  Nhân viên giao hàng nhiệt tình, luôn lắng nghe mọi ý kiến từ
                  khách hàng{" "}
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-6">
            <h3 className="bold mb10"> ĐĂNG NHẬP </h3>

            <div className="form-group mb30">
              Bạn chưa có tài khoản?
              <Link
                style={{ color: "#2264D1" }}
                className="bold"
                to="/register"
              >
                {" "}
                Đăng ký ngay
              </Link>
            </div>

            {/* Username Input */}
            <div className="form-group width60">
              <label htmlFor="exampleEmail">Email/số điện thoại </label>
              <input
                type="text"
                className={"form-control borradius3 " + UserActive}
                id="exampleEmail"
                ref={UsernameRef}
                value={Username}
                {...bindUserName}
                placeholder="Nhập Email hoặc số điện thoại"
              />
            </div>

            {/* Password Input */}
            <div className="form-group margin-top-20 width60">
              <label for="examplePass">Mật khẩu</label>
              <div className="input-group">
                <input
                  type={PassHide}
                  class={"form-control borradius3 " + PassActive}
                  id="examplePass"
                  placeholder="Nhập mật khẩu"
                  ref={PasswordRef}
                  value={Password}
                  {...bindPassword}
                  onKeyDown={(e) => CodeHandleKeyDown(e)}
                />
                <div className="input-group-append">
                  <span
                    className={"fa fa-fw fa-eye input-group-text " + PassEye}
                    onClick={(e) => {
                      setPassHide(PassEye === "" ? "text" : "password");
                      setPassEye(PassEye === "" ? "fa-eye-slash" : "");
                    }}
                  ></span>
                </div>
              </div>
            </div>
            <div className="form-group width60" style={{ color: "grey" }}>
              <Link
                className="pull-right"
                style={{ color: "#3e3838" }}
                to="/forgot"
              >
                Quên mật khẩu ?
              </Link>
            </div>
            {/* Login Button */}
            <div className="form-group text-center margin-top-20 width60">
              <button
                type="button"
                style={{ width: "100%" }}
                className="margin-top-20 btn text-transform btn-sm btn-save"
                onClick={onClickLogin}
                disabled={disable}
              >
                Đăng nhập
              </button>
            </div>
            <div
              className="col-md-12 width60"
              style={{ fontSize: "12px", marginBottom: "10px" }}
            >
              <span>
                Khi đăng nhập, quý khách đã đồng ý với{" "}
                <span
                  onClick={showModal}
                  style={{ cursor: "pointer", color: "red" }}
                >
                  Điều khoản sử dụng dịch vụ
                </span>{" "}
                của NETCO post.
              </span>
            </div>
            <div className="italic margin-top-15  mb30">{LoginMessage}</div>
          </div>
        </div>
      </div>

      {/* Modal xác thực 2 bước - Improved Design */}
      <Modal
        title={null}
        visible={showVerificationModal}
        footer={null}
        closable={true}
        maskClosable={false}
        onCancel={handleCloseVerification}
        centered
        width={540}
        closeIcon={<span style={{ fontSize: "20px", color: "#999" }}>✕</span>}
        bodyStyle={{
          padding: "0",
          borderRadius: "12px",
          overflow: "hidden",
        }}
      >
        <div
          style={{
            background: "linear-gradient(135deg, #00884e 0%, #006d3e 100%)",
            padding: "35px 40px 30px",
            color: "white",
            textAlign: "center",
          }}
        >
          <div
            style={{
              width: "160px",
              height: "auto",
              margin: "0 auto 18px",
              padding: "16px 20px",
              background: "white",
              borderRadius: "12px",
              display: "inline-block",
              boxShadow: "0 4px 16px rgba(0,0,0,0.1)",
            }}
          >
            <Img
              src="assets/img/LogoNetco.png"
              style={{
                width: "100%",
                height: "auto",
                display: "block",
              }}
            />
          </div>
          <h2
            style={{
              margin: "0 0 6px 0",
              fontSize: "26px",
              fontWeight: "700",
              color: "white",
              letterSpacing: "-0.5px",
            }}
          >
            Xác thực tài khoản
          </h2>
          <p
            style={{
              margin: 0,
              fontSize: "15px",
              color: "rgba(255,255,255,0.85)",
              fontWeight: "400",
            }}
          >
            Bảo vệ tài khoản của bạn
          </p>
        </div>

        <div style={{ padding: "40px" }}>
          {verificationStep === 1 ? (
            // Bước 1: Chọn phương thức xác thực
            <div>
              <p
                style={{
                  textAlign: "center",
                  marginBottom: "35px",
                  fontSize: "15px",
                  color: "#555",
                  lineHeight: "1.6",
                }}
              >
                Để bảo vệ quyền riêng tư và tiếp tục đăng nhập tài khoản trên
                thiết bị lạ, vui lòng xác nhận mã OTP bằng 1 trong 2 hình thức
                sau:
              </p>

              <div
                style={{
                  display: "flex",
                  gap: "15px",
                  marginBottom: "35px",
                }}
              >
                <button
                  onClick={() => setVerificationMethod("email")}
                  style={{
                    flex: 1,
                    height: "80px",
                    border:
                      verificationMethod === "email"
                        ? "2px solid #00884e"
                        : "2px solid #e8e8e8",
                    borderRadius: "12px",
                    background:
                      verificationMethod === "email" ? "#f0f9f4" : "white",
                    cursor: "pointer",
                    transition: "all 0.3s ease",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: "10px",
                    outline: "none",
                    boxShadow:
                      verificationMethod === "email"
                        ? "0 4px 12px rgba(0,136,78,0.15)"
                        : "0 2px 8px rgba(0,0,0,0.05)",
                  }}
                  onMouseEnter={(e) => {
                    if (verificationMethod !== "email") {
                      e.currentTarget.style.borderColor = "#00884e";
                      e.currentTarget.style.background = "#fafafa";
                    }
                  }}
                  onMouseLeave={(e) => {
                    if (verificationMethod !== "email") {
                      e.currentTarget.style.borderColor = "#e8e8e8";
                      e.currentTarget.style.background = "white";
                    }
                  }}
                >
                  <span
                    style={{
                      fontSize: "16px",
                      fontWeight: "600",
                      color:
                        verificationMethod === "email" ? "#00884e" : "#333",
                    }}
                  >
                    Email
                  </span>
                </button>

                <button
                  onClick={() => setVerificationMethod("zalo")}
                  style={{
                    flex: 1,
                    height: "80px",
                    border:
                      verificationMethod === "zalo"
                        ? "2px solid #00884e"
                        : "2px solid #e8e8e8",
                    borderRadius: "12px",
                    background:
                      verificationMethod === "zalo" ? "#f0f9f4" : "white",
                    cursor: "pointer",
                    transition: "all 0.3s ease",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: "10px",
                    outline: "none",
                    boxShadow:
                      verificationMethod === "zalo"
                        ? "0 4px 12px rgba(0,136,78,0.15)"
                        : "0 2px 8px rgba(0,0,0,0.05)",
                  }}
                  onMouseEnter={(e) => {
                    if (verificationMethod !== "zalo") {
                      e.currentTarget.style.borderColor = "#00884e";
                      e.currentTarget.style.background = "#fafafa";
                    }
                  }}
                  onMouseLeave={(e) => {
                    if (verificationMethod !== "zalo") {
                      e.currentTarget.style.borderColor = "#e8e8e8";
                      e.currentTarget.style.background = "white";
                    }
                  }}
                >
                  <span
                    style={{
                      fontSize: "16px",
                      fontWeight: "600",
                      color: verificationMethod === "zalo" ? "#00884e" : "#333",
                    }}
                  >
                    ZNS Zalo
                  </span>
                </button>
              </div>

              <Button
                type="primary"
                onClick={handleSelectMethod}
                block
                style={{
                  height: "50px",
                  borderRadius: "8px",
                  fontSize: "16px",
                  fontWeight: "600",
                  background: "#00884e",
                  border: "none",
                  boxShadow: "0 4px 12px rgba(0,136,78,0.3)",
                }}
              >
                Tiếp tục
              </Button>
            </div>
          ) : (
            // Bước 2: Nhập mã OTP
            <div>
              <div
                style={{
                  textAlign: "center",
                  marginBottom: "35px",
                }}
              >
                <p
                  style={{
                    fontSize: "15px",
                    color: "#666",
                    margin: 0,
                    lineHeight: "1.6",
                  }}
                >
                  Mã OTP đã được gửi đến{" "}
                  <strong>
                    {" "}
                    {verificationMethod === "email" ? "email" : "Zalo"}
                  </strong>
                </p>
                <p
                  style={{
                    fontSize: "16px",
                    fontWeight: "600",
                    color: "#00884e",
                    margin: "8px 0 0 0",
                  }}
                >
                  {maskedContact}
                </p>
                {verificationMethod === "email" && (
                  <div
                    style={{
                      marginTop: "12px",
                      padding: "8px 12px",
                      background: "#fff3cd",
                      borderLeft: "3px solid #ffc107",
                      borderRadius: "4px",
                    }}
                  >
                    <p
                      style={{
                        fontSize: "13px",
                        color: "#856404",
                        margin: 0,
                        lineHeight: "1.5",
                      }}
                    >
                      💡 <strong>Lưu ý:</strong> Nếu không thấy email, vui lòng
                      kiểm tra thư mục <strong>Spam/Junk</strong>
                    </p>
                  </div>
                )}
              </div>

              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  gap: "10px",
                  marginBottom: "25px",
                }}
              >
                {otpInputs.map((digit, index) => (
                  <Input
                    key={index}
                    id={`otp-input-${index}`}
                    maxLength={1}
                    value={digit}
                    onChange={(e) => handleOtpChange(index, e.target.value)}
                    autoComplete="off"
                    style={{
                      width: "50px",
                      height: "56px",
                      textAlign: "center",
                      fontSize: "24px",
                      fontWeight: "600",
                      borderRadius: "8px",
                      border: digit ? "2px solid #00884e" : "2px solid #e8e8e8",
                      background: digit ? "#f0f9f4" : "white",
                      transition: "all 0.3s ease",
                    }}
                    onKeyDown={(e) => {
                      if (e.key === "Backspace" && !digit && index > 0) {
                        const prevInput = document.getElementById(
                          `otp-input-${index - 1}`
                        );
                        if (prevInput) prevInput.focus();
                      } else if (e.key === "Enter") {
                        handleVerifyOtp();
                      }
                    }}
                  />
                ))}
              </div>

              <div style={{ textAlign: "center", marginBottom: "25px" }}>
                <Button
                  type="link"
                  disabled={countdown > 0}
                  onClick={handleSelectMethod}
                  style={{
                    color: countdown > 0 ? "#999" : "#00884e",
                    fontSize: "14px",
                    padding: 0,
                    height: "auto",
                  }}
                >
                  {countdown > 0 ? (
                    <span>
                      Gửi lại mã sau <strong>{countdown}s</strong>
                    </span>
                  ) : (
                    <span>
                      Chưa nhận được mã? <strong>Gửi lại</strong>
                    </span>
                  )}
                </Button>
              </div>

              <div style={{ display: "flex", gap: "10px" }}>
                <Button
                  onClick={() => setVerificationStep(1)}
                  style={{
                    flex: 1,
                    height: "48px",
                    borderRadius: "8px",
                    fontSize: "16px",
                    fontWeight: "500",
                    border: "2px solid #e8e8e8",
                  }}
                >
                  Quay lại
                </Button>
                <Button
                  type="primary"
                  onClick={handleVerifyOtp}
                  style={{
                    flex: 2,
                    height: "48px",
                    borderRadius: "8px",
                    fontSize: "16px",
                    fontWeight: "600",
                    background: "#00884e",
                    border: "none",
                    boxShadow: "0 4px 12px rgba(0,136,78,0.3)",
                  }}
                >
                  Xác nhận
                </Button>
              </div>
            </div>
          )}
        </div>
      </Modal>

      {/* Modal điều khoản */}
      <Modal
        className="policy-modal"
        title="Chính sách Quyền riêng tư và Điều khoản sử dụng"
        visible={isModalVisible}
        onOk={handleOk}
        onCancel={handleCancel}
        width={"55%"}
        centered
        okText="Đã hiểu"
        cancelText="Đóng"
      >
        <div className="policy-content">
          <h1>
            Chính sách Quyền riêng tư và Điều khoản sử dụng website NETCO POST
          </h1>
          <p>
            Chúng tôi, <strong>NETCO POST</strong>, cùng với các Chi nhánh của
            chúng tôi, cung cấp nhiều tính năng, ứng dụng mà bạn có thể sử dụng
            trên các thiết bị di động và các Điều khoản và Điều kiện này (“
            <strong>Điều khoản</strong>”) sẽ quy định việc bạn sử dụng App.
          </p>
          <h2>Để tạo Tài khoản website NETCO POST</h2>
          <p>
            Bạn cần phải đồng ý với <strong>Điều khoản Dịch vụ</strong> bên
            dưới.
          </p>
          <h2>Dữ liệu chúng tôi xử lý khi bạn sử dụng website NETCO POST</h2>
          <ul>
            <li>
              <strong>Thông tin cá nhân:</strong> Tên, CCCD/Passport, địa chỉ
              liên hệ, địa chỉ email, số điện thoại.
            </li>
            <li>
              <strong>Dữ liệu hoạt động trên App:</strong>
              <ul>
                <li>Xác nhận Tuân thủ Chính sách/Quy định công ty.</li>
                <li>
                  Các quy trình/quy định liên quan đến thu hộ/thanh toán COD.
                </li>
                <li>Truy cập hệ thống, tạo đơn hàng.</li>
                <li>Theo dõi đơn hàng, doanh thu, công nợ</li>
              </ul>
            </li>
            <li>
              <strong>Thông tin thiết bị:</strong> ID thiết bị, địa chỉ IP, dữ
              liệu cookie, vị trí.
            </li>
          </ul>
          <h2>Tại sao chúng tôi xử lý dữ liệu</h2>
          <ul>
            <li>Nhận dạng và xác thực bạn để đảm bảo bảo mật.</li>
            <li>Cập nhật và duy trì Dịch vụ.</li>
            <li>
              Tuân thủ quy định pháp luật và yêu cầu từ cơ quan chức năng.
            </li>
            <li>Giải quyết tranh chấp, xử lý gian lận, vi phạm pháp luật.</li>
          </ul>
          <h2>Bảo vệ thông tin người dùng</h2>
          <ol>
            <li>Áp dụng các biện pháp an ninh để bảo vệ dữ liệu cá nhân.</li>
            <li>Bạn có trách nhiệm cập nhật thông tin tài khoản.</li>
            <li>Bảo vệ mật khẩu và không chia sẻ với ai khác.</li>
            <li>Báo ngay cho chúng tôi nếu tài khoản bị xâm nhập.</li>
            <li>Không vi phạm quyền sở hữu trí tuệ.</li>
            <li>
              Tự chịu trách nhiệm với thông tin tạo lập, xác nhận qua website.
            </li>
          </ol>
          <h2>Thỏa thuận và chấp nhận</h2>
          <p className="policy-agreement">
            Khi truy cập và đăng nhập tài khoản, bạn đồng ý rằng bạn đã đọc và
            hiểu <strong>Chính sách</strong> này và đồng ý với việc NETCO sử
            dụng, xử lý thông tin cá nhân của bạn.
          </p>
        </div>
      </Modal>
    </div>
  );
};
export default LoginV4Component;
